import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";
import Slideshow from "../../assets/Slideshow/Slideshow"; // 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";





const Lo4HMW = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];

    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Design Challenge/ HMW</h1>
                <p></p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
                        </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-hmw">
                    <div className="content-lo4-hmw-text">
                    {/* <img src={gif2}></img> */}
                        <h1>HCD Workshop</h1>
                        <p>
                            I had a lecture during this semester about Human Centered Design, this lecture was a learning experience for me
                            to understand how to make a product while also makes it design focused on their needs and requirements, by applying
                            usability knowledge and technique.
                        </p>
                        <p>
                            I also was given an exercise to come up with a solution about how a consumer consume potato chips. I was given chips
                            to kinda figure what kind of problem that could happen if I eat the potato chips. After having a discussion with my group we noticed that there were a few problems
                            for example:
                            <ul>
                                <li>Opening the bags of chips is noisy,like a plastic sound</li>
                                <li>The bag is not enviromentally friendly because you can't recycle it</li>
                                <li>After opening the chips it is not available to close it</li>
                                <li>Some of the leftover chips could stuck on the very end of the chips bag</li>
                                <li>Our fingers could get dirty</li>
                            </ul>

                            Why do people eat chips?
                            <ul>
                                <li>First because of the taste</li>
                                <li>It is a good snack for movie activites</li>
                            </ul> 

                            Who?
                            <ul>
                                <li>Commonly a group of people</li>
                            </ul>

                            Where?
                            <ul>
                                <li>During gatherings</li>
                                <li>On movie nights</li>
                                <li>You could do it anywhere</li>
                            </ul>

                            Our Solution was to make the chips bag has a bowl where on the top part there is a lid zipper for people to open and close it. 
                        </p>
                        
                        
                        
                        
                        
                    </div>

                    <div className="content-lo4-hmw-text2">
                        <h1>HMW Question</h1>
                        <p>
                            We did a brainstorm on what we could do for our client, and I come up with most of the HMW (How Might We question). Some of the
                            Question was:
                            <ul>
                                <li>How might we make the minor feel like a must-have experience and not just a course?</li>
                                <li>How might we give students a preview of this minor content?</li>
                                <li>How might we use staff to promote this minor?</li>
                                <li>How might we use Social Media to spark curiousity?</li>
                                <li>How might we identify students who would benifit most from this minor?</li>
                                <li>How might we shot the unique value of this minor compare to others?</li>
                            </ul>
                        </p>
                        
                    </div>

                    {/* <div className="content-lo4-hmw-slideshow">
                        <Slideshow images={images} />

                    </div> */}

                    <div className="content-lo4-hmw-images">
                        
                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4HMW;